/* global wc_add_to_cart_params */

export default (function() {
	let singleProduct;
	let form;
	let cross_sells = [];

	function init(link, configurator) {
		singleProduct        = $('.js-single-product');
		form                 = configurator.find('form.variations_form');
		const closeLink      = configurator.find('.js-close-options');
		const addCrossSells  = configurator.find('.js-add-cross-sell');

		// Show/hide configurator options
		link.click({configurator: configurator}, showOptions);
		closeLink.click((e) => {
			e.preventDefault();
			closeOptions();
		});

		// Update Subtotal on checkbox change
		addCrossSells.change((e) => {
			const product_id    = form.find('input[name=product_id]').val();
			const quantity      = form.find('input[name=quantity]').val();
			const var_id        = form.find('input[name=variation_id]').val();
			const cross_sell_id = $(e.currentTarget).data('product-id');

			// If selected
			if ($(e.currentTarget).is(':checked')) {
				cross_sells.push(cross_sell_id);
			} else {
				const index = cross_sells.indexOf(cross_sell_id);
				if (index > -1) {
					cross_sells.splice(index, 1);
				}
			}

			// Always update
			updateSubTotal(product_id, quantity, var_id, cross_sells);
		});

		// Update Subtotal on variation change
		form.find('.js-add-to-cart').on('show_variation', (event, variation) => {
			const product_id = form.find('input[name=product_id]').val();
			const quantity   = form.find('input[name=quantity]').val();
			const var_id     = variation.variation_id;

			updateSubTotal(product_id, quantity, var_id, cross_sells);
		});
	}

	function showOptions(e) {
		e.preventDefault();
		const configurator = e.data.configurator;
		const confTop      = configurator.get(0).offsetTop;

		if (!singleProduct.hasClass('is-personalize')) {
			singleProduct.addClass('is-personalize');
			configurator.scrollTop(confTop);
		}

		return false;
	}

	function closeOptions() {
		singleProduct.removeClass('is-personalize');
	}

	function updateSubTotal(product_id, quantity, var_id, cross_sells) {
		const addToCart = form.find('.single_add_to_cart_button');
		const data   = {
			action      : 'update_single_product_subtotal',
			security    : window.theme.ajax_nonce,
			product_id  : product_id,
			variation_id: var_id,
			quantity    : quantity,
			cross_sells : cross_sells
		};

		// Update Product Subtotal
		$.ajax({
			url : wc_add_to_cart_params.ajax_url,
			type: 'post',
			data: data,
			beforeSend: () => {
				$(addToCart).addClass('disabled');
			},
			success: (response) => {
				const isDisabled = $(addToCart).closest('.woocommerce-variation-add-to-cart').hasClass('woocommerce-variation-add-to-cart-disabled');
				if(!isDisabled) {
					$(addToCart).removeClass('disabled');
				}

				(response.subtotal) && form.find('.js-add-to-cart a.js-open-leasing').attr('data-amount', response.subtotal);
				(response.subtotal_html) && form.find('.js-add-to-cart .woocommerce-variation-price .amount').first().replaceWith(response.subtotal_html);
			},
			error: (jqXHR, error) => {
				console.log(jqXHR, error);
			}
		});
	}

	return {
		init
	};
})();